import React from 'react';
import {userStatusService} from '../domain';
import {Disposers} from '../lib/helpers';

const refreshDelay = 5000;

export class UserStatusUnreachableScene extends React.Component {
  readonly disposers = new Disposers();

  componentDidMount() {
    let interval = setInterval(this.refreshAfterDelay, refreshDelay);
    this.disposers.add(() => clearInterval(interval));
  }

  refreshAfterDelay() {
    if (!userStatusService.status.isServerUnreachable)
      return;
    userStatusService.refreshWhoAmI();
  }

  render() {
    return (
      <div className="content-center">
        <div className="alert alert-info">Server is unreachable</div>
      </div>
    );
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
